import React from "react";
import { useTranslation } from "react-i18next";
import "./SearchOptions.scss";
import SearchOption from "../../SearchAgent/SearchOption/searchoption";
import {
  HOTELS,
  PACKAGES,
  PLANES,
  ORGANIZED_TOURS,
  useSearch,
  DYNAMIC_PACKAGES,
} from "../../../../contexts/SearchContext";
import { isAdminUser } from "../../../../services/authService";
import { useNavigate } from "react-router-dom";

const SearchOptions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { searchTab, setSearchTab: ogSetSearchTab } = useSearch();

  const setSearchTab = (tab) => {
    navigate("/p/dashboard/searchoffer");
    ogSetSearchTab(tab);
  };

  return (
    <div className="searchAgent-search-option-wrapper">
      <SearchOption
        id={HOTELS}
        selected={searchTab === HOTELS}
        title={t("searchagent.hotels")}
        action={setSearchTab}
      />
      <SearchOption
        id={DYNAMIC_PACKAGES}
        selected={searchTab === DYNAMIC_PACKAGES}
        title={t("searchagent.dynamicpackages")}
        action={setSearchTab}
        // disabled={isAdminUser() ? false : true}
      />
      <SearchOption
        id={PACKAGES}
        selected={searchTab === PACKAGES}
        title={t("searchagent.packages")}
        action={setSearchTab}
      />
      <SearchOption
        id={ORGANIZED_TOURS}
        selected={searchTab === ORGANIZED_TOURS}
        title={t("searchagent.organizedtours")}
        action={setSearchTab}
      />
      <SearchOption
        id={PLANES}
        selected={searchTab === PLANES}
        title={t("searchagent.planes")}
        action={setSearchTab}
        disabled
      />
    </div>
  );
};

export default SearchOptions;
